// KPI tile grid for a single-row `type: "table"` entry (various_stats /
// general_overview groups) - ports reporting-hub's VariousStatsPanel.tsx,
// which renders `entry.rows[0]` as a grid of small tiles (one per column)
// instead of an 11+ column table. Same per-tile hover formula tooltip as
// CalculationTable.js, via PrimeReact Tooltip.

import React from 'react';
import { Tooltip } from 'primereact/tooltip';
import { formatCalcValue, buildCellTooltip } from './calcFormat';

const TOOLTIP_TARGET_CLASS = 'cr-stat-tile-tooltip';

const VariousStatsPanel = ({ entry }) => {
  if (!entry || !entry.columns) return null;
  const row = (entry.rows || [])[0];
  if (!row) return <p className="cr-muted-text">No data for this selection.</p>;

  return (
    <div className="cr-kpi-grid">
      <Tooltip target={`.${TOOLTIP_TARGET_CLASS}`} />
      {entry.columns.map((col) => {
        const tooltip = buildCellTooltip(col, row);
        return (
          <div
            key={col.id}
            className={tooltip ? TOOLTIP_TARGET_CLASS : undefined}
            data-pr-tooltip={tooltip || undefined}
            data-pr-position="top"
            style={{ cursor: tooltip ? 'help' : undefined }}
          >
            <div className="cr-kpi-label">{col.label}</div>
            <div className="cr-kpi-value">
              {formatCalcValue(row[col.id] ?? null, col.format)}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default VariousStatsPanel;
